export default __webpack_public_path__ + "static/afiU-logo-horizontal-white-en-c0b149cdeb5798e339b69c734c9fa9aa.png";